import React, { useState, useContext, useEffect } from "react";
import { MenuItem, TextField, Button } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
import baseUrl from "../../../../BaseURL";
import { ContextData } from "../../../../context/Context";
import PopupDialog from "../../../PopupDialog/PopupDialog";
import SettingiewDialogue from "./popDialogue/SettingiewDialogue";
import StateList from "./statesAndLGAs/StateList";
import SoundAlert from "../../../../routes/SoundAlert";
import { Postrequest } from "../../../../context/AxiosRequest";

function AddBank() {


  // State for form inputs
  const [formData, setFormData] = useState({
    bank_name: "",
    agent_phone_number: "",
    bank_email: "",
    bank_branch: "",
    bank_address: "",
    bank_terms: ""
  });


  const [Reload, setReload] = useState(true);
  const { accesstoken } = useContext(ContextData);
 
  // Handler for input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handler for file input change
  const handleSubmit = () => {

    
    // Check for empty fields
    const isEmptyField = Object.values(formData).every((value) => value.trim() === "");

    if (isEmptyField) {

      SoundAlert("error");
      toast.error("Please fill out all fields");

    } else {

 
         (async ()=>{
                
         const response = await Postrequest("/auth/add_bank",formData,accesstoken)

         if (response.status) {
               setFormData({
                    bank_name: "",
                    agent_phone_number: "",
                    bank_email: "",
                    bank_branch: "",
                    bank_address: "",
                    bank_terms: ""
               })
          toast.success(response.textStatus);
          SoundAlert("success");
        
        }if(!response.status){

          SoundAlert("error");
          toast.error(response.textStatus);

        }

        setReload(!Reload);



         })()
     

    }
  };



  return (

    <div className="p-6 bg-gray-100 rounded-lg shadow-lg">
      <div className="flex justify-between items-center mb-4">

      <h2 className="text-xl font-semibold">Add Bank</h2>
       <div className="flex items-center space-x-2 cursor-pointer text-blue-600 hover:text-blue-800">
         <b>Add Bank</b>  <SettingiewDialogue />
       </div>
        </div>

      <form className="space-y-4 text-left">
 

        <TextField
          label="Bank Name"
          name="bank_name"
          value={formData.bank_name}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
           inputProps={{ maxLength:  30}}
        />
         
         <TextField 
          label=" Agent Phone Number"
          name="agent_phone_number"
          value={formData.agent_phone_number}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
           inputProps={{ maxLength:  11}}
           type="tel"
        />

      <TextField  
          label="Bank Email"
          name="bank_email"
          value={formData.bank_email}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
          type="email"
        />

       <p className="font-bold">Type: <span className="text-red-950">N/A</span>  if not available</p>
         
          <TextField  
          label="bank_branch"
          name="bank_branch"
          value={formData.bank_branch}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
           inputProps={{ maxLength:  30}}
        />

        
      <p className="font-bold">Type: <span className="text-red-950">N/A</span>  if not available</p>
      


        <TextField  
          label="Bank Terms"
          name="bank_terms"
          value={formData.bank_terms}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
          multiline
          rows={4}
          
         />

     
         <TextField  
          label="Bank Address"
          name="bank_address"
          value={formData.bank_address}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
          multiline
          rows={4}
           inputProps={{ maxLength:  50}}
         />
 

        <Button onClick={handleSubmit} variant="contained" color="primary" className="w-full">
          Add
        </Button>



      </form>


    </div>
  );
}

export default AddBank;
